var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({attrs:{"maxlength":_vm.maxLength,"min":_vm.minValue},domProps:{"value":_vm.value}},'input',_vm.$attrs,false),Object.assign({}, _vm.$listeners,
    {input: function (e) { return _vm.$emit('input', e.target.value); },
    focus: function (e) { return _vm.$emit('focus', e); }})))}
var staticRenderFns = []

export { render, staticRenderFns }